"use strict";
exports.__esModule = true;
exports.AccountService = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("ethers/lib/utils");
var chain_provider_1 = require("../factory/chain-provider");
var AccountService = /** @class */ (function () {
    function AccountService() {
    }
    AccountService.getBalance = function (address, chainID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var balance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainID)];
                    case 1: return [4 /*yield*/, (_a.sent()).getBalance(address)];
                    case 2:
                        balance = _a.sent();
                        return [2 /*return*/, {
                                rawBalance: balance.toString(),
                                formattedBalance: (0, utils_1.formatEther)(balance)
                            }];
                }
            });
        });
    };
    return AccountService;
}());
exports.AccountService = AccountService;
